import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface FireplacesProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Fireplaces: React.FC<FireplacesProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [fireplaces, set_fireplaces] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Interior Finishes']?.['Fireplaces'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Interior Finishes': { ...b.values?.['Interior Finishes'], 'Fireplaces': v } } })
    );
    const label = 'Fireplaces';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(fireplaces)}
                />
            ) : (
                <MoneyBox
                    id={'fireplaces'}
                    allowNegative={false}
                    value={fireplaces}
                    onChange={(value) => set_fireplaces(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
